import * as styles from '../FieldWrapper/FieldWrapper.styles';

export const textarea = styles.input;
